class FacetFiltersForm extends HTMLElement {
  facetForm = null

  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    this.facetForm = this.querySelector("form")
    this.facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this))
    this.handleSorting()

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop")
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape)
    this.bindSidebarControls()
    this.bindApplyButtons()
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener("popstate", onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById("ProductCount")
    const countContainerDesktop = document.getElementById("ProductCountDesktop")
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    )

    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"))
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading")
    if (countContainer) {
      countContainer.classList.add("loading")
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading")
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.renderProductCount(html)
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    FacetFiltersForm.renderProductCount(html)
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML)
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel")
      })
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML
    const container = document.getElementById("ProductCount")
    const containerDesktop = document.getElementById("ProductCountDesktop")
    container.innerHTML = count
    container.classList.remove("loading")
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove("loading")
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    )
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"))

    new Ajaxinate({
      container: "#product-grid",
      pagination: "#pagination-link",
      loadingText: '<div class="loader"><span></span></div>',
      offset: 500,
    })
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html")
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersFormSidebar .js-filter, #FacetFiltersPillsForm .js-filter"
    )
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersFormSidebar .js-filter, #FacetFiltersPillsForm .js-filter"
    )

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(({ id }) => {
          return currentElement.id === id
        })
      ) {
        currentElement.remove()
      }
    })

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined
      return jsFilter ? element.id === jsFilter.id : false
    }
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) =>
        !matchesId(element) && !element.classList.contains("sorting-filters")
    )
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      (element) =>
        matchesId(element) && !element.classList.contains("sorting-filters")
    )

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id)
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1]
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender)
            return
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender)
        }
      }
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    // FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        )
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        )

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID)
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector)
        if (newElementToActivate) newElementToActivate.focus()
      }
    }

    document.querySelectorAll("facet-filters-form").forEach((form) => {
      if (typeof form.bindSidebarControls === "function") {
        form.bindSidebarControls()
      }
    })
  }

  handleSorting() {
    const facetForm = this.facetForm

    const sortingOptions = facetForm.querySelectorAll(
      ".facet__sort-by .select__option"
    )

    const sortingInput = facetForm.querySelector(
      '.facet__sort-by input[name="sort_by"]'
    )

    sortingOptions?.forEach((option) => {
      option.addEventListener("click", (e) => {
        const activeOption = facetForm.querySelector(
          '.facet__sort-by .select__option[data-selected="selected"]'
        )

        activeOption.dataset.selected = ""
        sortingInput.value = e.target.dataset.value
        e.target.dataset.selected = "selected"

        const inputEvent = new Event("input", { bubbles: true })
        sortingInput.dispatchEvent(inputEvent)

        if (e.target.dataset.mobile === "true") {
          this.closest(".mobile-facets__wrapper")
            .querySelector("summary")
            .click()
        }
      })
    })
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
      "#FacetsWrapperDesktop",
      "#FacetsWrapperSidebar",
      ".mobile-facets__open",
      ".mobile-facets__count",
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)

    document
      .getElementById("FacetFiltersForm")
      ?.querySelector("menu-drawer")
      ?.bindEvents()

    const sidebarForm = document
      .getElementById("FacetFiltersFormSidebar")
      ?.closest("facet-filters-form")

    if (sidebarForm) {
      if (typeof sidebarForm.bindSidebarControls === "function") {
        sidebarForm.bindSidebarControls()
      }
      if (typeof sidebarForm.bindApplyButtons === "function") {
        sidebarForm.bindApplyButtons()
      }
    }

    const mainForm = document.getElementById("FacetFiltersForm")?.closest("facet-filters-form")
    if (mainForm && mainForm !== sidebarForm) {
      if (typeof mainForm.bindSidebarControls === "function") {
        mainForm.bindSidebarControls()
      }
      if (typeof mainForm.bindApplyButtons === "function") {
        mainForm.bindApplyButtons()
      }
    }
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ]

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML
    })

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents()
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary")
    const sourceSummary = source.querySelector(".facets__summary")

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML
    }

    const targetHeaderElement = target.querySelector(".facets__header")
    const sourceHeaderElement = source.querySelector(".facets__header")

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML
    }

    const targetWrapElement = target.querySelector(".facets-wrap")
    const sourceWrapElement = source.querySelector(".facets-wrap")

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      )
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          )
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list")
    const sourceFacetsList = source.querySelector(".mobile-facets__list")

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    )
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form)
    return new URLSearchParams(formData).toString()
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  bindSidebarControls() {
    const sidebarDetails = document.getElementById("FacetSidebar")
    if (!sidebarDetails) return

    const closeButtons = sidebarDetails.querySelectorAll(
      "[data-facet-sidebar-close]"
    )
    closeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        document.documentElement.classList.remove("overflow-hidden")
        sidebarDetails.removeAttribute("open")
      })
    })

    const backButtons = sidebarDetails.querySelectorAll(
      "[data-facet-sidebar-back]"
    )
    backButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const parentDetails = event.target.closest(".mobile-facets__details")
        if (parentDetails) parentDetails.removeAttribute("open")
      })
    })

    const summary = sidebarDetails.querySelector("summary")
    if (summary) {
      summary.addEventListener("click", () => {
        const isOpen = sidebarDetails.hasAttribute("open")
        if (isOpen) {
          document.documentElement.classList.remove("overflow-hidden")
        } else {
          document.documentElement.classList.add("overflow-hidden")
        }
      })
    }
  }

  bindApplyButtons() {
    const applyButtons = document.querySelectorAll("[data-facet-apply]")
    applyButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault()
        const form = event.target.closest("form")
        if (!form) return
        const searchParams = this.createSearchParams(form)
        this.onSubmitForm(searchParams, event)

        const sidebarDetails = event.target.closest("#FacetSidebar")
        if (sidebarDetails) {
          sidebarDetails.removeAttribute("open")
          document.documentElement.classList.remove("overflow-hidden")
        }

        const mobileDisclosure = event.target.closest(
          ".mobile-facets__wrapper details"
        )
        if (mobileDisclosure) {
          mobileDisclosure.removeAttribute("open")
        }
      })
    })
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const targetForm = event.target?.closest("form")
    const isMobileListCheckbox =
      event.target?.type === "checkbox" &&
      event.target.closest("ul.mobile-facets__list")
    if (isMobileListCheckbox) return
    const sortFilterForms = document.querySelectorAll("facet-filters-form form")
    const isSidebarForm =
      event.target.closest("form")?.id === "FacetFiltersFormSidebar"
    if (event.srcElement.className == "mobile-facets__checkbox" && !isSidebarForm) {
      const searchParams = this.createSearchParams(event.target.closest("form"))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = []
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile"

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm" ||
            form.id === "FacetFiltersFormSidebar"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list")
            noJsElements.forEach((el) => el.remove())
            forms.push(this.createSearchParams(form))
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form))
        }
      })
      this.onSubmitForm(forms.join("&"), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf("?") + 1
        )
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define("facet-filters-form", FacetFiltersForm)
FacetFiltersForm.setListeners()
class PriceRange extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    )
    this.setMinAndMaxValues()
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input")
    const minInput = inputs[0]
    const maxInput = inputs[1]
    if (maxInput.value) minInput.setAttribute("max", maxInput.value)
    if (minInput.value) maxInput.setAttribute("min", minInput.value)
    if (minInput.value === "") maxInput.setAttribute("min", 0)
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"))
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute("min"))
    const max = Number(input.getAttribute("max"))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define("price-range", PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector("a")
    facetLink.setAttribute("role", "button")
    facetLink.addEventListener("click", this.closeFilter.bind(this))
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form")
    form.onActiveFilterClick(event)
  }
}

customElements.define("facet-remove", FacetRemove)
